module.exports = __webpack_public_path__ + "../resources/img/storebadge_mx.4a5e40df.svg";